// extracted by mini-css-extract-plugin
export default {"floorPlanMap":"FloorPlanMap_floorPlanMap__J+JIu","mapImage":"FloorPlanMap_mapImage__+XPWI","maximized":"FloorPlanMap_maximized__XeKOL","minimized":"FloorPlanMap_minimized__oqHrL"};